"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _omit = _interopRequireDefault(require("transmute/omit"));

var propTypes = {
  autoFocus: _react.PropTypes.bool,
  propertyIndex: _react.PropTypes.number,
  value: _react.PropTypes.oneOfType([_react.PropTypes.string.isRequired, _react.PropTypes.number.isRequired])
};

var PropertyInputText =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputText, _React$Component);

  function PropertyInputText() {
    (0, _classCallCheck2.default)(this, PropertyInputText);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputText).apply(this, arguments));
  }

  (0, _createClass2.default)(PropertyInputText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoFocus) {
        this.focus();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "getValue",
    value: function getValue(value) {
      if (value == null) {
        return '';
      }

      return "" + value;
    }
  }, {
    key: "render",
    value: function render() {
      var transferableProps = (0, _omit.default)(['actions', 'baseUrl', 'caretRenderer', 'isExpandableTextInputEnabled', 'isInline', 'getProperty', 'multiCurrencyCurrencyCode', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'propertyInputComponentConfig', 'readOnlySourceData', 'resolver', 'showError', 'showPlaceholder', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'wrappers', 'onTracking', 'isRequired'], this.props);
      return _react.default.createElement(_UITextInput.default, (0, _extends2.default)({}, transferableProps, {
        "data-modalfocus": this.props.autoFocus,
        ref: "input",
        value: this.getValue(this.props.value),
        autoComplete: "off"
      }));
    }
  }]);
  return PropertyInputText;
}(_react.default.Component);

exports.default = PropertyInputText;
PropertyInputText.propTypes = propTypes;
PropertyInputText.defaultProps = _UITextInput.default.defaultProps;
module.exports = exports.default;